'use strict';

let POINTS = require('../utilities/constants').POINTS;

module.exports = {
    updateCrossSellProduct: function () {
        $('body').on('product:crossSellUpdate', function (e, data) {
            var $crossSellProducts = data.product.crossSellProducts;
            if ($('.cross-sell-product').length && $crossSellProducts.length) {
                for (var i=0; i < $crossSellProducts.length; i++) {
                    var $crossSellProductContainer = $('.cross-sell-product').eq(i);
                    var $crossSellProductVariant = $crossSellProducts[i];
                    $crossSellProductContainer.data('crosssell-pid', $crossSellProductVariant.id);
                    $crossSellProductContainer.data('crosssell-ismaster', $crossSellProductVariant.productType === 'master');
        
                    // enabling or disabling cross sell product button
                    var $crossSellButton = $crossSellProductContainer.find('.crosssell-button');
                    if ($crossSellProductVariant.available && (data.product.productType === 'master' || $crossSellProductVariant.readyToOrder)) {
                        $crossSellButton.removeAttr("disabled");
                    } else {
                        $crossSellButton.attr("disabled", true);
                        $crossSellButton.removeClass('selected');
                    }

                    // update cross sell product price
                    if ($crossSellProductVariant.price && $crossSellProductVariant.price.sales && $crossSellProductVariant.price.sales.formatted) {
                        $crossSellProductContainer.find('.crosssell-price').empty().append($crossSellProductVariant.price.sales.formatted);
                        $crossSellProductContainer.find('.crosssell-points').empty().append('(+' + $crossSellProductVariant.price.sales.points + ' ' + POINTS +')');
                    } else if ($crossSellProductVariant.price && $crossSellProductVariant.price.type === 'range') {
                        $crossSellProductContainer.find('.crosssell-price').empty().append($crossSellProductVariant.price.min.sales.formatted + ' - ' + $crossSellProductVariant.price.max.sales.formatted);
                        $crossSellProductContainer.find('.crosssell-points').empty().append('(+' + $crossSellProductVariant.price.min.sales.points + ' - ' + $crossSellProductVariant.price.max.sales.points + ' ' + POINTS + ')');
                    }  else { // disabling the cross sell button if price is not there
                        $crossSellButton.attr("disabled", true);
                        $crossSellButton.removeClass('selected');
                    }
        
                }
            }
        });
    },

    crossSellAttribute: function () {
        $(document).on('click', '.crosssell-button', function () {
            $(this).toggleClass('selected');
        });
    }
};